// Actions for the Agency Fulfilment Call Bot store module (STSMPD-1323).
//
// This slice is a lightweight, client-side cache of the latest call state per allocation so the
// Agency Shifts row can show a status Tag pill. It is populated by the AgencyCallModal as it
// short-polls the call service; the durable, team-visible record remains the admin alert + note.

import { AGENCY_CALL_STATE_SET, AGENCY_CALL_STATE_CLEAR } from './action-types'
import { CallAlertState, CallStatus } from './types'

export type SetCallStatePayload = {
  allocationId: number
  lastState: CallAlertState | null
  status: CallStatus
  callRequestId: string
}

export const setAgencyCallState = (payload: SetCallStatePayload) => ({
  type: AGENCY_CALL_STATE_SET as typeof AGENCY_CALL_STATE_SET,
  payload,
})
export type SetAgencyCallStateAction = ReturnType<typeof setAgencyCallState>

export const clearAgencyCallState = (allocationId: number) => ({
  type: AGENCY_CALL_STATE_CLEAR as typeof AGENCY_CALL_STATE_CLEAR,
  allocationId,
})
export type ClearAgencyCallStateAction = ReturnType<typeof clearAgencyCallState>

export type AgencyCallAction = SetAgencyCallStateAction | ClearAgencyCallStateAction
